import { cn } from "@/lib/utils";

interface ImageCountBadgeProps {
  current: number;
  total: number;
  className?: string;
}

export function ImageCountBadge({ current, total, className }: ImageCountBadgeProps) {
  const safeTotal = Math.max(total, 1);
  const safeCurrent = Math.min(Math.max(current, 1), safeTotal);

  return (
    <div className={cn("rounded-full bg-black/60 px-2.5 py-1 text-xs text-white", className)}>
      {safeCurrent}/{safeTotal}
    </div>
  );
}
